module.exports = __webpack_public_path__ + "fonts/medium.489cc82.woff";